<template>
  <div
    class="flex flex-col items-center px-7 text-gray-600 text-center pb-4 w-full"
  >
    <div class="text-lg leading-[20px]">
      {{ t('product.show.calendarNoDates.title') }}
    </div>
    <p class="text-sm mt-2 font-normal">
      {{ descriptionLabel }}
    </p>
    <div
      v-if="eventBuyBoxVisibleElements.requestButtons"
      class="mt-4 flex gap-2"
    >
      <client-only>
        <EventBuyBoxWatilistButton
          @click:waitlist="emit('click:request-date')"
        />

        <EventBuyBoxRequestDateButton
          v-if="showDateRequestButton"
          class=""
          @click:request-date="emit('click:request-date')"
        />
      </client-only>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { EventDescription } from '~/composables/types/event'
import EventBuyBoxWatilistButton from '~/components/event/buybox/EventBuyBoxWatilistButton.vue'
import { useIsSubdomain } from '~/composables/useSubdomain'

const emit = defineEmits(['click:request-date'])
const { t } = useI18n()

const eventData = inject<EventDescription>('eventData')!
const isSubdomain = useIsSubdomain()

const eventBuyBoxVisibleElements = {
  requestButtons: true,
  ...(inject('eventBuyBoxVisibleElements') as {
    requestButtons?: boolean
    calendar?: boolean
  }),
}

const showDateRequestButton = computed(() =>
  eventGetters.isDateRequestActiveBS(eventData, isSubdomain)
)

const descriptionLabel = computed(() => {
  if (!showDateRequestButton.value) {
    return t('product.show.calendarNoDates.description.waitlist')
  } else {
    return t('product.show.calendarNoDates.description.waitlistAndDateRequest')
  }
})
</script>
